import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { blogPost } from '../../../Models/Session';
import { BaseApiService } from '../../../Services/base-api.service';


@Component({
  selector: 'app-page-detail',
  templateUrl: './page-detail.component.html',
  styleUrls: ['./page-detail.component.css'],standalone:false
})
export class PageDetailComponent implements OnInit{

  itemId:any;
  posts!:blogPost
  sessionDataArray: blogPost[] = [];
  loading:boolean=false;
  constructor
  (
    private api:BaseApiService,
    private http:HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private messageService:MessageService,


  )
  {

  }

  isLegalPage(): boolean {
    return (
      this.posts?.title?.includes('Disclaimer') ||
      this.posts?.title?.includes('Conditions Générales') ||
      this.posts?.title?.includes('Politique de Confidentialité')
      ||this.posts?.title?.includes('À Propos de Nous')
    );
  }
  
  getdat(id:any){
    this.loading=true;
    this.api.read(`Page/GetByPageId?id=${id}`).subscribe
    (
      (response)=>{
        this.posts = response;
        this.loading=false;
      }
      ,(
        error
      )=>{
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }



  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.itemId = params['id'];
      this.getdat(this.itemId);
    });


  }
}
